"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.InfoArticle = InfoArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.articleCategoryAddApi = articleCategoryAddApi;
exports.articleCategoryDelApi = articleCategoryDelApi;
exports.articleCategoryListApi = articleCategoryListApi;
exports.articleCategorySwitchApi = articleCategorySwitchApi;
exports.articleCategoryUpdateApi = articleCategoryUpdateApi;
exports.articleSwitchApi = articleSwitchApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 删除文章
 * @param id
 * @constructor
 */
function DelArticle(id) {
  return (0, _request.default)({
    url: "admin/platform/article/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 文章详情
 * @param id
 * @constructor
 */
function InfoArticle(id) {
  return (0, _request.default)({
    url: "admin/platform/article/info/".concat(id),
    method: 'get'
  });
}

/**
 * 文章列表
 * @param params
 * @constructor
 */
function ListArticle(params) {
  var data = {
    author: params.author,
    cid: params.cid,
    page: params.page,
    limit: params.limit,
    title: params.title,
    searchType: params.searchType,
    content: params.content
  };
  return (0, _request.default)({
    url: 'admin/platform/article/list',
    method: 'GET',
    params: data
  });
}

/**
 * 新增文章
 * @param params
 * @constructor
 */
function AddArticle(params) {
  var data = {
    author: params.author,
    cid: params.cid,
    content: params.content,
    cover: params.cover,
    isBanner: params.isBanner,
    isHot: params.isHot,
    sort: params.sort,
    synopsis: params.synopsis,
    title: params.title,
    url: params.url
  };
  return (0, _request.default)({
    url: 'admin/platform/article/save',
    method: 'post',
    data: data
  });
}

/**
 * 更新文章
 * @param params
 * @constructor
 */
function UpdateArticle(params) {
  var data = {
    author: params.author,
    cid: params.cid,
    content: params.content,
    cover: params.cover,
    isBanner: params.isBanner,
    isHot: params.isHot,
    sort: params.sort,
    synopsis: params.synopsis,
    title: params.title,
    id: params.id
  };
  return (0, _request.default)({
    url: 'admin/platform/article/update',
    method: 'post',
    data: data
  });
}

/**
 * 新增文章分类
 * @param data
 * @constructor
 */
function articleCategoryAddApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/article/category/add',
    method: 'POST',
    data: data
  });
}

/**
 * 删除文章分类
 * @param data
 * @constructor
 */
function articleCategoryDelApi(row) {
  return (0, _request.default)({
    url: "admin/platform/article/category/delete/".concat(row.id),
    method: 'POST'
  });
}

/**
 * 文章分类分页列表
 * @constructor
 */
function articleCategoryListApi() {
  return (0, _request.default)({
    url: "admin/platform/article/category/list",
    method: 'GET'
  });
}

/**
 * 修改文章分类
 * @param data
 * @constructor
 */
function articleCategoryUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/platform/article/category/update",
    method: 'POST',
    data: data
  });
}

/**
 * 文章开关
 * @param data
 */
function articleSwitchApi(id) {
  return (0, _request.default)({
    url: "admin/platform/article/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 文章分类开关
 * @param data
 */
function articleCategorySwitchApi(id) {
  return (0, _request.default)({
    url: "admin/platform/article/category/switch/".concat(id),
    method: 'POST'
  });
}